import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, "Bác sĩ khám", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_component_Panel, { header: "Xác nhận khám bệnh" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", null, "Tên bệnh nhân: " + _toDisplayString($setup.updateBook.full_name), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("label", null, "Số điện thoại: " + _toDisplayString($setup.updateBook.phone_number), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("label", null, "Triệu chứng: " + _toDisplayString($setup.updateBook.symptoms), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("label", null, "Thời gian: " + _toDisplayString($setup.updateBook.formatted_time) + " ( " + _toDisplayString($setup.getDay()) + ", ngày " + _toDisplayString($setup.updateBook.date_register) + " )", 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", null, "Địa chỉ: " + _toDisplayString($setup.updateBook.address) + ", " + _toDisplayString($setup.updateBook.ward_name) + ", " + _toDisplayString($setup.updateBook.district_name) + ", " + _toDisplayString($setup.updateBook.province_name), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Dropdown, {
            id: "doctor",
            filter: true,
            showClear: true,
            modelValue: $setup.updateBook.doctor,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.updateBook.doctor = $event)),
            options: $setup.doctors,
            optionLabel: "name",
            optionValue: "name",
            placeholder: "Vui lòng lựa chọn bác sĩ khám..."
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createVNode(_component_Button, {
        disabled: !$setup.valid(),
        label: "Khám xong",
        icon: "pi pi-check",
        iconPos: "left",
        onClick: $setup.done
      }, null, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
}